import React, { useEffect } from 'react';
import { EMPTY_RECORD, useDetailRecord } from 'helpers/detailRequest';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FaHistory, FaStream } from 'react-icons/fa';
import { getBooking } from 'redux/booking/car/carBookingSlice';
import useBreadcrumb from 'hooks/useBreadcrumb';
import { Card, Tabs, DetailRecordFallback } from 'components/common';
import TransactionDetailHeader from 'components/app/bookings/car/transaction/detail/TransactionDetailHeader';
import TransactionDetailInfo from 'components/app/bookings/car/transaction/detail/TransactionDetailInfo';
import BookingActivity from 'components/app/bookings/car/transaction/detail/BookingActivity';

const CarBookingDetail = () => {
  const dispatch = useDispatch();
  const params = useParams();
  // Only the record in the URL — the persisted store can still hold the one
  // viewed last (e.g. when opened from an email link).
  const { record, waiting, error } = useDetailRecord('booking_car', params.id);
  const transaction = record || EMPTY_RECORD;

  useBreadcrumb(
    transaction
      ? [
          { label: 'Car Booking', to: '/booking/car/list' },
          { label: transaction.code || transaction.booking_code || `Booking ${params.id}` },
        ]
      : null,
  );

  useEffect(() => {
    dispatch(getBooking(params.id));
  }, [params, dispatch]);

  const tabs = [
    { label: 'Detail', icon: <FaStream size={13} />, content: <TransactionDetailInfo transaction={transaction} /> },
    { label: 'Activities history', icon: <FaHistory size={13} />, content: <BookingActivity /> },
  ];

  if (!record) return <DetailRecordFallback waiting={waiting} title="Booking not available" error={error} onRetry={() => dispatch(getBooking(params.id))} />;

  return (
    <div className="tw-p-4">
      <TransactionDetailHeader transaction={transaction} />

      <Card padding="none">
        <Tabs
          variant="underline"
          lazyMount
          navClassName="tw-px-3 tw-pt-2 tw-bg-white"
          contentClassName="tw-bg-slate-50 tw-p-4"
          tabs={tabs}
        />
      </Card>
    </div>
  );
};

export default CarBookingDetail;
